export const DOCS_BRANCH = process.env.DOCS_BRANCH ?? 'main';

export const ROOT_DOCS_PATH = '/docs';

export const LOCAL_DOCS_DIRECTORY = 'public/docs-local'
